export const VISIBILITY = ['PUBLIC', 'HIDDEN'] as const
export type Visibility = (typeof VISIBILITY)[number]
